export const FormLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="rounded-lg grid-cols-1 grid gap-9 p-5 rounded-lg border border-base">
      {children}
    </div>
  );
};
